import { ModelConversationDetail } from "~/services/conversation/dto/conversation.detail.dto";

export const useIsShowLoading = () => useState<boolean>('useIsShowLoading', () => false);
export const useNats = () => useState<any>('useNats', () => undefined);
export const useServiceData = () => useState<any>('useServiceData', () => ({}));
export const useConversationData = () => useState<ModelConversationDetail>('useConversationData', () => new ModelConversationDetail());
export const useConversationActiveId = () => useState<string>('useConversationActiveId', () => '');
export const useIsDuringAIMessage = () => useState<boolean>('useIsDuringAIMessage', () => false);
export const useIsMessageMaxToken = () => useState<boolean>('useIsMessageMaxToken', () => false);
export const useUserAuthData = () => useState<any>('useUserAuthData', () => ({}));
export const useStreamAbortController = () => useState<AbortController | null>('useStreamAbortController', () => null);
